export const getMaxLengthErrorMessage = () => 'Maximum aantal karakters bereikt - ';
